import Loading from './Loading/Loading';
export default Loading;
